<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { getTranslationLanguageLabel } from 'dashboard/constants/translationLanguages';
import { useConversationTranslation } from 'dashboard/composables/useConversationTranslation';

const props = defineProps({
  conversationId: {
    type: Number,
    required: true,
  },
  previewText: {
    type: String,
    default: '',
  },
});

const { t } = useI18n();
const conversationIdRef = computed(() => props.conversationId);

const { settings, isActive } = useConversationTranslation(conversationIdRef);

const contactLanguageLabel = computed(() =>
  getTranslationLanguageLabel(settings.value.contactLanguage)
);

const showBanner = computed(
  () => isActive.value && !props.previewText
);

const showPreview = computed(
  () =>
    settings.value.enabled &&
    settings.value.sendTranslation &&
    settings.value.sendPreview &&
    props.previewText
);
</script>

<template>
  <div v-if="showBanner || showPreview" class="px-3 pt-2">
    <p
      v-if="showBanner"
      class="text-xs text-n-slate-11 bg-n-alpha-1 rounded-lg px-3 py-2"
    >
      {{
        t('CONVERSATION.TRANSLATION.SEND_STATUS', {
          language: contactLanguageLabel,
        })
      }}
    </p>
    <div
      v-if="showPreview"
      class="mt-2 rounded-lg border border-n-weak bg-n-alpha-1 px-3 py-2"
    >
      <p class="text-xs text-n-slate-11 mb-1">
        {{ t('CONVERSATION.TRANSLATION.PREVIEW_LABEL') }}
      </p>
      <p class="text-sm text-n-slate-12 whitespace-pre-wrap">
        {{ previewText }}
      </p>
    </div>
  </div>
</template>
